import { ref, computed, onMounted } from 'vue';
import { fetchCampaignInsights, storageData } from '../data';
const insights = ref(null);
const lastOtoInsightsViewDate = ref(null);
export function useCampaignsInsights() {
    const hasUserViewedOtoInsightsToday = computed(() => {
        const today = storageData.getTodayFormatted();
        const lastViewDate = lastOtoInsightsViewDate.value;
        return today === lastViewDate;
    });
    async function loadCampaignsInsights() {
        try {
            insights.value = await fetchCampaignInsights();
        }
        catch {
            insights.value = null;
        }
    }
    function handleUserViewedOtoInsights() {
        if (hasUserViewedOtoInsightsToday.value)
            return;
        const today = storageData.getTodayFormatted();
        storageData.setLastViewDate(today);
        lastOtoInsightsViewDate.value = today;
    }
    onMounted(() => {
        lastOtoInsightsViewDate.value = storageData.getLastViewDate();
    });
    return {
        insights,
        lastOtoInsightsViewDate,
        hasUserViewedOtoInsightsToday,
        loadCampaignsInsights,
        handleUserViewedOtoInsights,
    };
}
